import styled from '@emotion/styled';
import { H2, H3, SmallText } from 'ds/components/typography';

const CONTENT_MAX_WIDTH = 1144;
const MOBILE_NAVIGATION_HEIGHT = 48;


export const Root = styled.div`
  display: flex;
  flex-direction: column;
  ${({ theme }) => `
    min-height: 100vh;
    padding-top: ${theme.spacing(4)};
  `}
  ${({ theme }) => theme.media.showAt({ at: 1 })`
    padding-top: ${MOBILE_NAVIGATION_HEIGHT + Number.parseInt(theme.spacing(4), 10)}px;
  `}
`;

export const MainHeader = styled(H2.withComponent('h1'))`
  ${({ theme }) => `
    color: ${theme.colors.neutrals.grey1};
  `}
  ${({ theme }) => theme.media.showAt({ from: 2 })`
    margin-top: ${theme.spacing(5)};
  `}
`;
MainHeader.defaultProps = { weight: 'bold' };

export const ContentWrapper = styled.div`
  ${({ theme }) => `
    padding: 0 ${theme.spacing(2)};
    display: flex;
    justify-content: center;
  `}
`;

export const Content = styled.div`
  flex: 1 0 auto;
  max-width: ${CONTENT_MAX_WIDTH}px;
  width: 100%;
`;

export const AgenciesSection = styled.div`
  ${({ theme }) => theme.media.showAt({ at: 1 })`
    padding-top: ${theme.spacing(5)};
  `}
  ${({ theme }) => theme.media.showAt({ from: 2 })`
    padding-top: ${theme.spacing(6)};
  `}
`;

export const AgentsSection = styled.div`
  ${({ theme }) => theme.media.showAt({ at: 1 })`
    padding-top: ${theme.spacing(6)};
    padding-bottom: ${theme.spacing(8)};
  `}
  ${({ theme }) => theme.media.showAt({ from: 2 })`
    padding-top: ${theme.spacing(6)};
    padding-bottom: ${theme.spacing(9)};
  `}
`;

export const SectionHeader = styled(H3.withComponent('h2'))`
  ${({ theme }) => `
    color: ${theme.colors.neutrals.grey1};
  `}
`;
SectionHeader.defaultProps = { weight: 'bold' };

export const CardsCount = styled(SmallText)`
  ${({ theme }) => `
    color: ${theme.colors.neutrals.grey2};
  `}
`;

export const CardsCountHeader = styled(SmallText)`
  ${({ theme }) => `
    margin-top: ${theme.spacing(1)};
    margin-bottom: ${theme.spacing(4)};
    display: flex;
    flex-direction: row;
    align-items: flex-start;
  `}
`;

export const AutocompleteWrapper = styled.div`
  ${({ theme }) => `
    max-width: 312px;
    margin-top: ${theme.spacing(2)};
    input {
      height: 32px;
    }
  `}
`;

export const MobileNavigation = styled.nav`
  ${({ theme }) => `
    z-index: 1;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    display: flex;
    align-items: center;
    background: ${theme.colors.neutrals.white};
    height: ${MOBILE_NAVIGATION_HEIGHT}px;
    padding: ${theme.spacing(1)} ${theme.spacing(3)};
    border-bottom: 1px solid ${theme.colors.neutrals.grey8};
    input {
      height: 32px;
      max-width: 232px;
    }
    > a {
      margin-${theme.isRTL ? 'left' : 'right'}: ${theme.spacing(2)};
    }
  `}
`;

export const CardsGridHeaderNote = styled(SmallText)<{ isInSeparateLine?: boolean }>`
  ${({ theme, isInSeparateLine }) => `
    padding-top: ${theme.spacing(1)};
    line-height: 1.54;
    color: ${theme.colors.neutrals.grey3};
    ${isInSeparateLine ? `
      order: 1;
      min-width: 100%;
    ` : ''}
  `}
`;
